var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Icon, TouchFeedback } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 */
export default class Input extends React.PureComponent {
    constructor(props) {
        super(props);
        this.refInput = React.createRef();
        this.onInputChange = (e) => {
            const el = e.target;
            const { value: rawVal, selectionEnd: prePos } = el;
            const { value: preCtrlVal = '' } = this.state;
            const { type } = this.props;
            let ctrlValue = rawVal;
            switch (type) {
                case 'number':
                    ctrlValue = rawVal.replace(/\D/g, '');
                    break;
                case 'money':
                    ctrlValue = rawVal.replace(/[^\d.]/g, '');
                    break;
                case 'phone':
                    ctrlValue = rawVal.replace(/\D/g, '').substring(0, 11);
                    const valueLen = ctrlValue.length;
                    if (valueLen > 3 && valueLen < 8) {
                        ctrlValue = `${ctrlValue.substr(0, 3)} ${ctrlValue.substr(3)}`;
                    }
                    else if (valueLen >= 8) {
                        ctrlValue = `${ctrlValue.substr(0, 3)} ${ctrlValue.substr(3, 4)} ${ctrlValue.substr(7)}`;
                    }
                    break;
                case 'bankCard':
                    ctrlValue = rawVal.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ');
                    break;
                default:
            }
            this.handleOnChange(ctrlValue, e, () => {
                switch (type) {
                    case 'bankCard':
                    case 'phone':
                        // 受控输入类型需要调整插入符号的位置
                        try {
                            // 设置选择可能会抛出错误 (https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange)
                            let pos = this.calcPos(prePos || 0, preCtrlVal, rawVal, ctrlValue, [' '], /\D/g);
                            if ((type === 'phone' && (pos === 4 || pos === 9)) || (type === 'bankCard' && (pos > 0 && pos % 5 === 0))) {
                                pos -= 1;
                            }
                            el.selectionStart = el.selectionEnd = pos;
                        }
                        catch (error) {
                            console.warn('Set selection error:', error);
                        }
                        break;
                    default:
                }
            });
        };
        // 计算插入符号的位置
        this.calcPos = (prePos, preCtrlVal, rawVal, ctrlVal, placeholderChars, maskReg) => {
            const editLength = rawVal.length - preCtrlVal.length;
            const isAddition = editLength > 0;
            let pos = prePos;
            if (isAddition) {
                const additionStr = rawVal.substr(pos - editLength, editLength);
                let ctrlCharCount = additionStr.replace(maskReg, '').length;
                pos -= (editLength - ctrlCharCount);
                let placeholderCharCount = 0;
                while (ctrlCharCount > 0) {
                    if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                        ctrlCharCount--;
                    }
                    else {
                        placeholderCharCount++;
                    }
                }
                pos += placeholderCharCount;
            }
            return pos;
        };
        this.handleOnChange = (value, event, adjustPos) => {
            const { onChange } = this.props;
            // 受控组件的一些限制操作
            if (('value' in this.props)) {
                this.setState({ value: this.props.value });
            }
            else {
                this.setState({ value });
            }
            // 修复光标错位问题
            setTimeout(() => {
                adjustPos();
            });
            onChange && onChange(event, this);
        };
        this.handleOnBlur = (e) => {
            const { onBlur } = this.props;
            onBlur && onBlur(e);
            this.reportValidity();
        };
        /**
         * 提示校验失败的情况
         * */
        this.reportValidity = () => {
            const report = this.checkValidity();
            this.setState({ isWarn: !report.valid });
            return report;
        };
        this.getStyleValue = (dom, style) => window.getComputedStyle(dom).getPropertyValue(style);
        this.state = {
            isWarn: false,
            value: props.value || props.defaultValue || '',
            defaultValue: props.defaultValue
        };
    }
    componentDidMount() {
        this.value = this.state.value || '';
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if ('value' in nextProps && nextProps.value !== prevState.value) {
            return { value: nextProps.value };
        }
        else if ('defaultValue' in nextProps && nextProps.defaultValue !== prevState.defaultValue) {
            return { value: nextProps.defaultValue, defaultValue: nextProps.defaultValue };
        }
        return null;
    }
    componentDidUpdate() {
        // 为 textarea 自动计算高度
        if (this.props.autoSize && this.props.type === 'textarea') {
            const textareaDom = this.elem;
            const paddingHeight = parseInt(this.getStyleValue(textareaDom, 'padding-top')) + parseInt(this.getStyleValue(textareaDom, 'padding-bottom'));
            textareaDom.style.height = ''; // fix：行数减少时，高度不发生变化的问题
            textareaDom.style.height = `${textareaDom.scrollHeight - paddingHeight}px`;
        }
    }
    render() {
        const { value, isWarn } = this.state;
        const _a = this.props, { prefixCls, type, rows, className, disabled, hidden, clearable, onChange, requiredMessage, patternMessage, minLengthMessage, maxLengthMessage, autoSize, defaultValue } = _a, resetProps = __rest(_a, ["prefixCls", "type", "rows", "className", "disabled", "hidden", "clearable", "onChange", "requiredMessage", "patternMessage", "minLengthMessage", "maxLengthMessage", "autoSize", "defaultValue"]);
        const classNames = cls(prefixCls, {
            'x-disabled': disabled,
            [`${prefixCls}-warn`]: isWarn
        });
        const props = Object.assign({}, resetProps, { ref: this.refInput, value, className: classNames, disabled, onBlur: this.handleOnBlur, onChange: this.onInputChange });
        return (<div hidden={hidden} className={`${prefixCls}-wrap ${className}`}>
        {type === 'textarea'
            ? <textarea {...props} rows={rows}/>
            : <input hidden={hidden} {...props} type={this.getInputType()}/>}
        {clearable && value !== '' && !('value' in this.props)
            ? <TouchFeedback activeClassName={`${prefixCls}-clear`}>
            <Icon className={`${prefixCls}-clear x-icon-close-circle`} onClick={() => {
                this.reset();
                this.focus();
            }}/>
          </TouchFeedback>
            : null}
      </div>);
    }
    get value() {
        let value = this.elem.value;
        switch (this.props.type) {
            case 'phone':
            case 'bankCard':
                value = value.replace(/ /g, '');
                break;
            default:
        }
        return this.props.trim ? value.trim() : value;
    }
    set value(value) {
        this.elem.value = value;
        this.setState({ value });
        this.onInputChange({ target: this.elem });
    }
    get elem() {
        return this.refInput.current;
    }
    // 以下格式化函数剽窃于 ant 😄
    getInputType() {
        let inputType = this.props.type || 'text';
        switch (inputType) {
            case 'phone':
            case 'bankCard':
                return 'tel';
            case 'digit':
                return 'number';
            case 'money':
                return 'text';
            default:
                return inputType;
        }
    }
    /**
     * 重置当前输入域
     * @public
     * */
    reset() {
        this.value = '';
    }
    /**
     * 令当前控件获得焦点
     * @public
     * */
    focus() {
        this.elem.focus();
    }
    /**
     * 令当前控件失去焦点
     * @public
     * */
    blur() {
        this.elem.blur();
    }
    /**
     * 验证当前输入框
     * @public
     * */
    checkValidity() {
        const { type, pattern, patternMessage, noValidate, onValidate, required, minLength, requiredMessage, minLengthMessage, maxLength, maxLengthMessage } = this.props;
        let valid = true, message = patternMessage, value = this.value;
        // 自定义校验
        if (onValidate)
            return onValidate(value, this);
        // 无需校验
        if (noValidate)
            return { valid: true, message: null };
        // 必填字段校验
        if (value == null || value.length === 0 && (Array.isArray(value) || typeof value === 'string')) {
            return required ? { valid: false, message: requiredMessage } : { valid: true, message: null };
        }
        // 长度校验
        const length = value.length;
        if (minLength && minLength !== -1 && length < minLength) {
            return {
                valid: false,
                // @ts-ignore
                message: (minLengthMessage || '').replace('{bound}', minLength).replace('{delta}', (minLength - length))
            };
        }
        else if (maxLength && maxLength !== -1 && length > maxLength) {
            return {
                valid: false,
                // @ts-ignore
                message: (maxLengthMessage || '').replace('{bound}', maxLength).replace('{delta}', (length - maxLength))
            };
        }
        // 格式校验
        switch (type) {
            case 'phone':
                valid = /^1\d{10}$/.test(value);
                break;
            case 'money':
                valid = /^(0|[1-9]\d*)(\.\d\d?)?$/.test(value);
                break;
            case 'digit':
                valid = /^\d*$/.test(value);
                break;
            case 'email':
                valid = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
                break;
            case 'chineseId':
                valid = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}(\d|x|X)$/.test(value);
                break;
            default:
                if (pattern instanceof RegExp) {
                    valid = pattern.test(value);
                }
        }
        return { valid, message: valid ? null : message };
    }
}
Input.defaultProps = {
    prefixCls: 'x-input',
    className: '',
    rows: 2,
    type: 'text',
    disabled: false,
    clearable: true,
    noValidate: false,
    maxLength: -1,
    minLength: -1,
    requiredMessage: `该字段为必填项`,
    patternMessage: '该字段格式不正确',
    minLengthMessage: `该字段最少长度为 {bound}，缺少 {delta}`,
    maxLengthMessage: `该字段最大长度为 {bound}，超出 {delta}`
};
